/* eslint-disable import/no-cycle */
import * as types from './types';
import accountApi from '@/modules/account/api/accountApi';
import reportingApi from '@/modules/reporting/api/reportingApi';

const actions = {
  [types.FETCH_REPORTS_ADVERTISERS]: (context, payload) => accountApi.fetchReportAdvertisers(payload)
    .then((response) => response)
    .catch((error) => {
      throw error;
    }),
  [types.DOWNLOAD_REPORT_CSV]: (context, payload) => reportingApi.downloadReportAsCSV(payload)
    .then((response) => response)
    .catch((error) => {
      throw error;
    }),
  [types.SET_SELECTED_FILTER]: (context, payload) => {
    context.commit(types.SET_SELECTED_FILTER, payload);
  },
  [types.SET_SELECTED_ADVERTISER_DETAILS]: (context, payload) => {
    context.commit(types.SET_SELECTED_ADVERTISER_DETAILS, payload);
  },
  [types.RESET_STORE]: (context) => {
    context.commit(types.RESET_STORE);
  },
};
export default actions;
